export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  ALTERNATIVE = 'alternative',
  YELLOW = 'yellow',
  OUTLINE = 'outline',
  PETROL = 'petrol',
}

export enum ButtonSize {
  BIG = 'big',
  MEDIUM = 'medium',
  SMALL = 'small',
  TEXT = 'text',
}
